import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "row row-title align-items-end" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row row-content mb-4" }
const _hoisted_9 = { class: "row row-product-filter" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_AdvancedPanelSwitcher = _resolveComponent("AdvancedPanelSwitcher")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TitleMetaInputComponent = _resolveComponent("TitleMetaInputComponent")!
  const _component_AdvancedPanel = _resolveComponent("AdvancedPanel")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_ProductFilterPicker = _resolveComponent("ProductFilterPicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_AdvancedPanelSwitcher, {
                    class: "mb-3",
                    "is-advanced": _ctx.isAdvancedTitleMeta,
                    errors: _ctx.errors,
                    onToggleAdvanced: _ctx.toggleAdvancedTitleMeta
                  }, null, 8, ["is-advanced", "errors", "onToggleAdvanced"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.title_size_code,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.title_size_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.enumTitleSizeCode,
                    label: _ctx.$t('size'),
                    name: "size",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.contentBlock.title,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.title) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('title'),
                    name: "title",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ])
              ]),
              _createVNode(_component_AdvancedPanel, {
                "is-show-when-advanced": true,
                "is-advanced": _ctx.isAdvancedTitleMeta,
                class: "bg-light pt-3 ms-3 mb-3 p-3 pt-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TitleMetaInputComponent, {
                    modelValue: _ctx.contentBlock.title_meta,
                    errors: _ctx.errors,
                    "onUpdate:modelValue": _ctx.onTitleMetaUpdate
                  }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["is-advanced"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_InputTextEditor, {
                  modelValue: _ctx.contentBlock.content,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.content) = $event)),
                    _ctx.onChange
                  ],
                  label: _ctx.$t('content'),
                  name: "content",
                  class: "col-12",
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('productFilter'),
                mb: "3"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ProductFilterPicker, {
                    payload: _ctx.productFilterPickerPayload,
                    "product-filter": _ctx.productFilter,
                    errors: _ctx.errors,
                    onPayloadChanged: _ctx.onProductFilterPickerChanged,
                    onProductFilterChanged: _ctx.onProductFilterChanged
                  }, null, 8, ["payload", "product-filter", "errors", "onPayloadChanged", "onProductFilterChanged"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}